// extracted by mini-css-extract-plugin
export default {"price":"h8-z","onSale":"i8-z","msrpLabelPrice":"j8-z","msrpLabel":"k8-z","originalPrice":"l8-z","percentOff":"m8-z"};